import { Dropdown } from 'antd'

export default function View({ identity, onLogout, onUpdatePassword }) {
  const handlers = {
    logout: onLogout,
    update: onUpdatePassword,
  }

  const items = [
    {
      key: 'update',
      label: '修改密码',
      icon: <span className='text-gray-700 fa fa-key mr-1' />,
    },
    {
      key: 'logout',
      label: '注销登录',
      icon: <span className='text-gray-700 fa fa-sign-out mr-1' />,
    },
  ]

  return <div className='flex h-full items-center justify-end pr-4'>
    <Dropdown menu={{ items, onClick: item => handlers[item.key]?.() }}>
      <div className='text-lg cursor-pointer mr-3'>
        <span className='fa fa-commenting-o' />
        <span className='fa fa-cog mx-1' />
        <span className='text-base'>{identity?.user?.nickname}</span>
      </div>
    </Dropdown>
  </div>
}
